export default function TrustStrip() {
  return (
    <section className="py-8 md:py-10 bg-background-50 border-y border-background-200/70">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
              <i className="ri-refresh-line text-primary-600 text-lg"></i>
            </div>
            <span className="text-sm font-medium text-foreground-700">Updated Weekly Supplier Database</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-check-line text-accent-600 text-lg"></i>
            </div>
            <span className="text-sm font-medium text-foreground-700">Verified China Agent Listings</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
              <i className="ri-global-line text-primary-600 text-lg"></i>
            </div>
            <span className="text-sm font-medium text-foreground-700">Used by Resellers Worldwide</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
              <i className="ri-flashlight-line text-accent-600 text-lg"></i>
            </div>
            <span className="text-sm font-medium text-foreground-700">Fast Access. No Hidden Fees.</span>
          </div>
        </div>
      </div>
    </section>
  );
}